import {Injectable} from '@angular/core';
import {HttpResponse} from '@angular/common/http';

@Injectable({
    providedIn: 'root'
})
export class HttpCacheService extends Map<string, HttpResponse<any>> {

    constructor() {
        super();
    }
}
